module.exports = __webpack_public_path__ + "img/Phone_Black@3x.b29f0fbf.png";